import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
    const closeMobileMenu = () => {
        const sidebar = document.querySelector('.app-sidebar');
        const overlay = document.querySelector('.sidebar-overlay');
        const hamburgerIcon = document.querySelector('.hamburger-btn i');
        
        if (sidebar) sidebar.classList.remove('mobile-open');
        if (overlay) overlay.classList.remove('active');
        if (hamburgerIcon) {
            hamburgerIcon.classList.remove('bx-x');
            hamburgerIcon.classList.add('bx-menu');
        }
    };

    return (
        <div className="app-wrapper">
            <Sidebar />
            <div className="sidebar-overlay" onClick={closeMobileMenu}></div>
            <div className="app-main">
                <Header />
                <div className="app-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Layout;
